module.exports = __webpack_public_path__ + "static/media/abbv_agn_drugs_shortened.7ea1a37f.mp3";